export enum IndexType {
  NO_INDEX = 'NO_INDEX',
  NO_FACET = 'NO_FACET',
  NO_CITY_FACET = 'NO_CITY_FACET',
  REGION_FACET_ONLY = 'REGION_FACET_ONLY',
  COUNTRY_FACET_ONLY = 'COUNTRY_FACET_ONLY',
  FULL_INDEX = 'FULL_INDEX'
}
